import React from "react";
import { GstPrintableReport } from "./GstPrintableReport.jsx";

export function GstReportTabPanes({ activeTab, summary, tables, printableRef, reportData, company, periodLabel }) {
  return (
    <div style={{ minHeight: "220px", maxHeight: "440px", overflowY: "auto", overflowX: "auto", WebkitOverflowScrolling: "touch", border: "1px solid var(--border-subtle)", borderRadius: "8px", padding: "0.5rem" }}>
      {/* 📄 Audit Report Sheet (Always mounted in DOM with printableRef so html2pdf can ALWAYS capture it!) */}
      <div
        style={{
          display: activeTab === "SHEET" ? "block" : "none"
        }}
      >
        <div
          ref={printableRef}
          id="gst-printable-report-card"
          style={{
            background: "#ffffff",
            color: "#111827",
            padding: "1rem",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            boxSizing: "border-box"
          }}
        >
          <GstPrintableReport reportData={reportData} company={company} periodLabel={periodLabel} />
        </div>
      </div>

      {activeTab === "3B" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "0.4rem 0.6rem", background: "var(--bg-card)", borderRadius: "4px", fontSize: "0.85rem" }}>
            <span>Total Outward Taxable Supplies:</span>
            <strong>₹{summary.totalSalesTaxable.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "0.4rem 0.6rem", background: "var(--bg-card)", borderRadius: "4px", fontSize: "0.85rem" }}>
            <span>Total Output Tax (CGST + SGST + IGST):</span>
            <strong style={{ color: "var(--accent-blue)" }}>₹{summary.salesTax.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "0.4rem 0.6rem", background: "var(--bg-card)", borderRadius: "4px", fontSize: "0.85rem" }}>
            <span>Eligible Input Tax Credit (Purchases):</span>
            <strong style={{ color: "var(--success)" }}>₹{summary.purchasesItc.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</strong>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "0.6rem 0.8rem", background: "rgba(234, 179, 8, 0.1)", border: "1px solid rgba(234, 179, 8, 0.3)", borderRadius: "6px", fontSize: "0.95rem" }}>
            <span style={{ fontWeight: "700" }}>Net Tax to Pay via Cash Challan:</span>
            <strong style={{ color: "var(--warning)" }}>₹{summary.netPayable.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</strong>
          </div>
        </div>
      )}

      {activeTab === "B2B" && (
        <table className="data-table" style={{ fontSize: "0.78rem", width: "100%" }}>
          <thead>
            <tr>
              <th>Inv #</th>
              <th>Customer</th>
              <th>GSTIN</th>
              <th style={{ textAlign: "right" }}>Taxable</th>
              <th style={{ textAlign: "right" }}>Tax</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {tables.b2bInvoices.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: "center", color: "var(--text-dim)" }}>No B2B invoices found</td></tr>
            ) : (
              tables.b2bInvoices.map((inv) => (
                <tr key={inv.id}>
                  <td style={{ fontWeight: "600" }}>{inv.invoiceNo}</td>
                  <td>{inv.customerName}</td>
                  <td style={{ fontFamily: "monospace", fontSize: "0.72rem" }}>{inv.customerGstin}</td>
                  <td style={{ textAlign: "right" }}>₹{inv.taxableValue.toFixed(0)}</td>
                  <td style={{ textAlign: "right" }}>₹{inv.totalTax.toFixed(0)}</td>
                  <td style={{ textAlign: "right", fontWeight: "700" }}>₹{inv.grandTotal.toFixed(0)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {activeTab === "B2C" && (
        <table className="data-table" style={{ fontSize: "0.78rem", width: "100%" }}>
          <thead>
            <tr>
              <th>Category</th>
              <th>State POS</th>
              <th style={{ textAlign: "right" }}>Bills</th>
              <th style={{ textAlign: "right" }}>Taxable</th>
              <th style={{ textAlign: "right" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {tables.b2cSummary.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: "center", color: "var(--text-dim)" }}>No B2C sales recorded</td></tr>
            ) : (
              tables.b2cSummary.map((b, idx) => (
                <tr key={idx}>
                  <td>{b.type}</td>
                  <td>State {b.pos}</td>
                  <td style={{ textAlign: "right" }}>{b.count}</td>
                  <td style={{ textAlign: "right" }}>₹{b.taxableValue.toFixed(0)}</td>
                  <td style={{ textAlign: "right", fontWeight: "700" }}>₹{b.total.toFixed(0)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {activeTab === "HSN" && (
        <table className="data-table" style={{ fontSize: "0.78rem", width: "100%" }}>
          <thead>
            <tr>
              <th>HSN Code</th>
              <th>Description</th>
              <th style={{ textAlign: "right" }}>Qty</th>
              <th style={{ textAlign: "right" }}>Taxable</th>
              <th style={{ textAlign: "right" }}>Tax</th>
            </tr>
          </thead>
          <tbody>
            {tables.hsnSummary.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: "center", color: "var(--text-dim)" }}>No HSN items recorded</td></tr>
            ) : (
              tables.hsnSummary.map((hsn) => (
                <tr key={hsn.hsnCode}>
                  <td style={{ fontWeight: "600" }}>{hsn.hsnCode}</td>
                  <td>{hsn.description}</td>
                  <td style={{ textAlign: "right" }}>{hsn.totalQty} {hsn.unit}</td>
                  <td style={{ textAlign: "right" }}>₹{hsn.taxableValue.toFixed(0)}</td>
                  <td style={{ textAlign: "right" }}>₹{(hsn.cgst + hsn.sgst + hsn.igst).toFixed(0)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {activeTab === "PURCHASE" && (
        <table className="data-table" style={{ fontSize: "0.78rem", width: "100%" }}>
          <thead>
            <tr>
              <th>Bill #</th>
              <th>Vendor</th>
              <th>GSTIN</th>
              <th style={{ textAlign: "right" }}>Taxable</th>
              <th style={{ textAlign: "right" }}>ITC (Tax)</th>
              {summary.totalPurchasesTcs > 0 && <th style={{ textAlign: "right" }}>TCS</th>}
            </tr>
          </thead>
          <tbody>
            {tables.purchaseRegister.length === 0 ? (
              <tr><td colSpan={summary.totalPurchasesTcs > 0 ? 6 : 5} style={{ textAlign: "center", color: "var(--text-dim)" }}>No purchases in this period</td></tr>
            ) : (
              tables.purchaseRegister.map((pur) => (
                <tr key={pur.id}>
                  <td style={{ fontWeight: "600" }}>{pur.vendorBillNo}</td>
                  <td>{pur.vendorName}</td>
                  <td style={{ fontFamily: "monospace", fontSize: "0.72rem" }}>{pur.vendorGstin}</td>
                  <td style={{ textAlign: "right" }}>₹{pur.taxableValue.toFixed(0)}</td>
                  <td style={{ textAlign: "right", fontWeight: "700", color: "var(--success)" }}>₹{pur.totalTax.toFixed(0)}</td>
                  {summary.totalPurchasesTcs > 0 && <td style={{ textAlign: "right" }}>{pur.tcs > 0 ? `₹${pur.tcs.toFixed(2)}` : "—"}</td>}
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
